let mutations = {
    setIsShowGenduPopup(state, data) {
        state.isShowGendu = data;
    },
    setIsShowWendaPopup(state, data) {
        state.isShowWenda = data;
    },
    setLastShow: (state, data) => {
    	state.lastShow = data;
    }
}
export default mutations;


// WEBPACK FOOTER //
// ./src/vuex/modules/habitLower/mutations.js